import { KeycloakOidcProvider } from "@synthesis/shared-auth";
import { NuqsAdapter } from "nuqs/adapters/react";
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { handleZodError } from "@synthesis/shared-services";

import { NotificationsStoreProvider } from "../components/notifications-panel/notifications-panel.lib";

import { EacdRouterProvider } from "./eacd-router-provider";
import { NoticeCenter, Portal, Sidebar, SnackbarCenter } from "@synthesis/shared-ui";

// Логирует расхождения контракта (ZodError от валидации ответа) детально в консоль —
// видно в runtime, что фактически пришло против ожидаемого. handleZodError реагирует только на ZodError.
const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => handleZodError(error, `query ${JSON.stringify(query.queryKey)}`),
  }),
  mutationCache: new MutationCache({
    onError: (error, _vars, _ctx, mutation) => handleZodError(error, `mutation ${JSON.stringify(mutation.options.mutationKey)}`),
  }),
  defaultOptions: {
    queries: {
      retry: 1,
    },
  },
});

export const App = () => (
  <KeycloakOidcProvider>
    <DndProvider backend={HTML5Backend}>
      <NuqsAdapter>
        <QueryClientProvider client={queryClient}>
          <NotificationsStoreProvider>
            <Sidebar>
              <EacdRouterProvider />
            </Sidebar>
          </NotificationsStoreProvider>
          <Portal>
            <SnackbarCenter duration={3000} position="bottom-center" />
            <NoticeCenter />
          </Portal>
        </QueryClientProvider>
      </NuqsAdapter>
    </DndProvider>
  </KeycloakOidcProvider>
);
